module.exports = __webpack_public_path__ + "media/images/text_overlay_test-398d0ae0808e4b16a58680e02c3d06ff.jpg";